
// import { useNavigate } from 'react-router';
// import './App.css'

// function App() {

//   // const apiUrl = process.env.REACT_SRC_PATH;
//   const apiUrl = import.meta.env.VITE_REACT_SRC_PATH;

//   const navigate = useNavigate();
//   return (
//     <main className="App" style={{ padding:"none",height:"100%",overflow:"none" }}>

// <button 
//         onClick={() => navigate('/credit')} 
//         style={{
//           position: 'absolute', 
//           bottom: '20px', 
//           left: '90%', 
//           transform: 'translateX(-50%)', 
//           padding: '8px 16px', 
//           background: 'black', 
//           color: '#fff', 
//           border: 'none', 
//           borderRadius: '5px',
//           fontSize: '14px',
//           cursor: 'pointer',
//           zIndex: 10
//         }}
//       >
//         Credits
//       </button>


//       <iframe src={apiUrl}
//       style={{
//         padding:"none",
//         overflow:"none" ,
//         height:"99svh",
//         width:"100%",
//         border: "none"
//         }}/> 
//     </main>
//   )
// }

// export default App


import { useState } from 'react';
import Credit from './Credit';
import './App.css';

function App() {
  const apiUrl = import.meta.env.VITE_REACT_SRC_PATH;
  const [showCreditPopup, setShowCreditPopup] = useState(false);

  return (
    <main className="App" style={{ position: 'relative', height: '100vh', overflow: 'hidden' }}>
      {/* Credit Button */}
      <button 
        onClick={() => setShowCreditPopup(true)} 
        style={{
          position: 'absolute', 
          bottom: '20px', 
          left: '90%', 
          transform: 'translateX(-50%)', 
          padding: '8px 16px', 
          background: 'black', 
          color: '#fff', 
          border: 'none', 
          borderRadius: '5px',
          fontSize: '14px',
          cursor: 'pointer',
          zIndex: 10
        }}
      >
        Credits
      </button>

      {/* Popup Modal */}
      {showCreditPopup && (
        <div 
          style={{
            position: 'fixed', 
            top: 0, 
            left: 0, 
            width: '100%', 
            height: '100%', 
            background: 'rgba(0, 0, 0, 0.8)', 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            zIndex: 20
          }}
        >
          <div 
            style={{
              position: 'relative', 
              background: '#fff', 
              padding: '20px', 
              width: '90%', 
              maxWidth: '600px', 
              borderRadius: '10px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
              overflowY: 'auto',
              maxHeight: '80vh'
            }}
          >
            {/* Close Button */}
            <button 
              onClick={() => setShowCreditPopup(false)} 
              style={{
                position: 'absolute', 
                top: '5px', 
                right: '5px', 
                background: 'red', 
                color: '#fff', 
                border: 'none', 
                borderRadius: '5px', 
                padding: '2px 5px',
                cursor: 'pointer'
              }}
            >
              X
            </button>

            {/* Credit Component */}
            <Credit />
          </div>
        </div>
      )}

      {/* Main Content (iFrame) */}
      <iframe 
        src={apiUrl}
        style={{
          height: '100%',
          width: '100%',
          border: 'none'
        }}
      />
    </main>
  );
}

export default App;
